"use strict";

var userCan = {
  mixins: [require("./UserOwns.js")],

  methods: {
    userCan: function userCan() {
      var _Fn;

      return (_Fn = Fn).userCan.apply(_Fn, arguments);
    },
    userHasPermission: function userHasPermission() {
      var _Fn2;

      return (_Fn2 = Fn).userHasPermission.apply(_Fn2, arguments);
    },
    isAdmin: function isAdmin() {
      return Fn.isAdmin();
    },
    whereUserCan: function whereUserCan() {
      var _Fn3;

      return (_Fn3 = Fn).whereUserCan.apply(_Fn3, arguments);
    },
    hasResponsibilities: function hasResponsibilities() {
      var _Fn4;

      return (_Fn4 = Fn).hasResponsibilities.apply(_Fn4, arguments);
    },
    isTestLeader: function isTestLeader() {
      var _Fn5;

      return (_Fn5 = Fn).isTestLeader.apply(_Fn5, arguments);
    },
    isCurrentUser: function isCurrentUser() {
      var _Fn6;

      return (_Fn6 = Fn).isCurrentUser.apply(_Fn6, arguments);
    }
  },

  computed: {
    canUpdateOccasion: function canUpdateOccasion() {
      return this.userOwns(this.occasion) || Fn.userCan("update_occasions", "project", this.project.id) && moment(this.occasion.end_date).add(1, "days").isSameOrAfter(moment());
    }
  }
};

module.exports = userCan;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/mixins/UserCan.js
// module id = TxoU
// module chunks = 0 1